<div class="px-container">
  <div class="section-title">
    <h2>User profile</h2>
  </div>
  <div>
    <phx-tabset #routingTab type="pills" [options]="tabInfo"  ></phx-tabset>
  </div>
</div>